import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface FinancialSummaryTranslations {
    title: string;
    totalAssets: string;
    totalDebts: string;
    netWorth: string;
}

const ENGLISH_TRANSLATIONS: FinancialSummaryTranslations = {
    title: 'Financial Summary',
    totalAssets: 'Total Value of Assets',
    totalDebts: 'Total Value of Debts',
    netWorth: 'Approximate Net Value of Estate',
};

const FRENCH_TRANSLATIONS: FinancialSummaryTranslations = {
    title: 'Sommaire financier',
    totalAssets: 'Valeur totale des actifs',
    totalDebts: 'Valeur totale des dettes',
    netWorth: 'Valeur nette approximative de la succession',
};

export const FINANCIAL_SUMMARY_TRANSLATIONS: Record<
    TemplateFormLanguage,
    FinancialSummaryTranslations
> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getFinancialSummaryTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): FinancialSummaryTranslations {
    return FINANCIAL_SUMMARY_TRANSLATIONS[language] ?? FINANCIAL_SUMMARY_TRANSLATIONS.en;
}
